import styled from '@emotion/styled';
import { media } from '../../../style/global-style';

export const StyledCabinWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    ${media.tablet`
        height: 315px;
        width: 500px;
    `}

    ${media.desktop`
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
    `}
`;

export const StyledSection = styled.section`
    height: 300px;
    position: relative;
    ${media.tablet`
        height: 350px;
    `}
`;

export const StyledCabinContainer = styled.section`
    max-width: 1170px;
    position: relative;
    width: 100%;
`;
